import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const UnderReviewRenewApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewUnderReviewApplications.role,
    permissionsConfig.editRenewUnderReviewApplications.action,
    permissionsConfig.editRenewUnderReviewApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewUnderReviewApplications.role,
    permissionsConfig.deleteRenewUnderReviewApplications.action,
    permissionsConfig.deleteRenewUnderReviewApplications.type
  );

  return (
    <StatusApplication appStatus="7" title="Under Review" subTitle="Under Review" application_type="1" pageFrom="renew/under-review" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default UnderReviewRenewApplications